import i18n from 'constants/translation/i18n';

export const stepsDataManagement = () => [
  {
    title: i18n.t('STEP_AUDIT_FINDINGS_MANAGEMENT'),
    url: '/dataManagement/auditFindings'
  },
  {
    title: i18n.t('STEP_CATEGORY_MANAGEMENT'),
    url: '/dataManagement/category'
  },
  {
    title: i18n.t('STEP_PRODUCT_MANAGEMENT'),
    url: '/dataManagement/product'
  }
];

export const stepsCompliance = () => [
  {
    title: i18n.t('STEP_BASELINE_DEFINITION'),
    url: '/complianceEst/clientReq'
  },
  {
    title: i18n.t('STEP_GAPS_AUDIT_FINDING_MANAGEMENT'),
    url: '/complianceEst/gapsAndAuditFindings'
  },
  {
    title: i18n.t('STEP_SOLUTION_DEFINITION'),
    url: '/complianceEst/solutionDefinition'
  },
  {
    title: i18n.t('STEP_TASK_DEFINITION'),
    url: '/complianceEst/tasksDefinition'
  },
  {
    title: i18n.t('STEP_EVIDENCE_DEFINITION'),
    url: '/complianceEst/evidenceDefinition'
  }
];
